import _ from 'lodash';
import validator from 'validator'; // https://www.npmjs.com/package/validator 참고

// null/undefined 확인
export function isEmpty(val: any): boolean {
  if (typeof val === 'number') {
    return val === undefined || val === null || Number.isNaN(val);
  }
  return _.isEmpty(val);
}

// 숫자확인
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function isNotInt(val: string | number): boolean {
  return !validator.isInt(String(val));
}

// 비밀번호
export function isNotStrongPassword(val?: string): boolean {
  return !validator.isStrongPassword(val ?? '', {
    minLength: 9, // 9자리 이상
    minLowercase: 1, // 소문자 포함
    minUppercase: 1, // 대문자 포함
    minNumbers: 1, // 숫자 포함
    minSymbols: 1, // 특수기호 포함
    returnScore: false,
    pointsPerUnique: 1,
    pointsPerRepeat: 0.5,
    pointsForContainingLower: 10,
    pointsForContainingUpper: 10,
    pointsForContainingNumber: 10,
    pointsForContainingSymbol: 10,
  });
}

// 여러항목(array)중 최소 한개 정보가 있는지
export function isEmptyArray(val?: Record<any, any>): boolean {
  return !(typeof val === 'object' && val.length > 0);
}
